<div class="container d-flex justify-content-center p-3 ">
  <div class="row">
    <div class="col ">
      <div class="table-responsive">
        <table class=" table-fixed">
          <thead>
            <tr>
              <th class="btnGroup">
                <mat-button-toggle-group value="12hour" #timeFormat="matButtonToggleGroup" aria-label="Time Format">
                  <mat-button-toggle [checked]="true" value="12hour">12-hour</mat-button-toggle>
                  <mat-button-toggle value="24hour">24-hour</mat-button-toggle>
                </mat-button-toggle-group>
              </th>
              <th *ngFor="let row of arr; index as day" class="text-center">
                {{row.name}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let hour of hours; index as time">
              <td class="border-0">
                <p class="text-right mr-2 text-center">{{getTime( time+1, timeFormat.value)}}</p>
              </td>
              <td class="text-center" *ngFor="let cell of hCells; index as c">
                <mat-checkbox (change)="click(c, time+1, $event)" id="{{c}}-{{time+1}}"
                  [checked]="getIsChecked(c, time+1)"></mat-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
